module.exports = __webpack_public_path__ + "static/0029-b5ec3112eb8152c69eca7f17a147761e.png";